import { render, staticRenderFns } from "./SantaderFinSim.vue?vue&type=template&id=a62bf172&"
import script from "./SantaderFinSim.vue?vue&type=script&lang=js&"
export * from "./SantaderFinSim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports